// Section configurations for the quiz lookup management
export const sections = [
  {
    key: 'difficulty',
    title: 'Difficulty Levels Management',
    tabLabel: 'Difficulty Levels',
    headers: ['Sr No.', 'Level Name', 'Display Image', 'Base Time', 'Base Points', 'Quick Times', 'Late Times', 'Wrong Times', 'Wrong Penalty', 'Status'],
  },
  {
    key: 'question-type',
    title: 'Question Types Management',
    tabLabel: 'Question Types',
    headers: ['Sr No.', 'Type Name', 'Display Name', 'Status', 'Update at'],
  },
  {
    key: 'answer-type',
    title: 'Answer Types Management',
    tabLabel: 'Answer Types',
    headers: ['Sr No.', 'Type Name', 'Display Name', 'Status', 'Update at'],
  },
  {
    key: 'question-mood',
    title: 'Question Moods Management',
    tabLabel: 'Question Moods',
    headers: ['Sr No.', 'Mood Name', 'Display Name', 'Status', 'Update at'],
  },
  {
    key: 'question-topic',
    title: 'Question Topics Management',
    tabLabel: 'Question Topics',
    headers: ['Sr No.', 'Topic Name', 'Display Name', 'Status', 'Update at'],
  },
  {
    key: 'question-subtopic',
    title: 'Question Sub-Topics Management',
    tabLabel: 'Question Sub-Topics',
    headers: ['Sr No.', 'Topic', 'Sub-Topic Name', 'Display Name', 'Status', 'Update at'],
  },
  {
    key: 'question-bank',
    title: 'Question Banks Management',
    tabLabel: 'Question Banks',
    headers: ['Sr No.', 'Bank Name', 'Status', 'Created at'],
  },
  {
    key: 'games',
    title: 'Games Management',
    tabLabel: 'Games',
    headers: ['Sr No.', 'Game Name', 'Description', 'Status', 'Created at'],
  },
  {
    key: 'games-datestamps',
    title: 'Games Datestamps Management',
    tabLabel: 'Games Datestamps',
    headers: ['Sr No.', 'Game Name', 'Date Stamp Name', 'Description', 'Status', 'Created at'],
  }
];
